angular.module('rental')
    .component("rentalResourceList", {
        bindings: {
            page: "<",
            filters: "<",
            statistics: "<"
        },
        templateUrl: "app/rental/resource/list.html",
        controller: function ($scope, $httpParamSerializer, $state, $stateParams, Dictionary, RentalResourceConst, RentalResourceService, RentalAgreementService) {
            this.reset = () => this.filters = {filter: this.filters.filter}
            this.RentalResourceService = RentalResourceService
            this.RentalAgreementService = RentalAgreementService

            this.$onInit = () => {
                this.types = Dictionary.list({type: 'rental-resource-type'})
            }

            this.getExportUrl = () => {
                return "/crm/api/rental-resource-batch/export?" + $httpParamSerializer($stateParams)
            }

            this.isIndexationExpired = item => {
                return moment(item.nextIndexationDate).isBefore(moment())
            }

            this.searchFieldPopover = `
                <div>Prefiksy:</div>
                <div><b>ile*</b> - wielkość/liczba/ilość od__do</div>
            `
            this.searchFieldPopoverAgreement = `
                <div>Prefiksy:</div>
                <div><b>ile*</b> - wielkość/liczba/ilość od__do</div>
                <div><b>cena*</b> - koszt jedn. netto od__do</div>
            `

            $scope.$on(RentalResourceConst.eventUpdate, () => $state.reload());
            $scope.$on(RentalResourceConst.eventDelete, () => $state.reload());
        }
    })
